import {ACTION_CODE} from './_actionCode';
import {DealService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { UserState } from '../../reducers/UserReducer';
import { Deal } from '../../models/deal/deal';
const FUNCTION_CODE = 'GET_ALL_DEALS';

export async function getAllDeals(
    userData: UserState['userProfileData'],
    params = "",
    page = 1,
) {
    try {
        LoggerService.logInfo('Action - getAllDeals - Start'
        );

        const getAllDealsResult = await DealService.getAllDeals(userData, params, page);

        const {data, metadata} = getAllDealsResult;

        LoggerService.logInfo('Action - getAllDeals - Success');

        return ResultModel.newSuccessResultTyped<Deal[]>(data, metadata);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllDeals - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des affaires',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
